import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function OtMenu() {
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">

            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>

                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>

            </Link>

        </div>
    );
    return (
        <section className="container-fluid mt-4">

            <h5 className="menu-section-title">Operation Theatre</h5>

            <div className="row">

                <MenuCard link="/surgery-type" title="Surgery Type" icon="fa-solid fa-scissors" color="#0d6efd"/>

                <MenuCard link="/ot-entry" title="OT Entry" icon="fa-solid fa-notes-medical" color="#20c997"/>

                <MenuCard link="/ot-list" title="OT List" icon="fa-solid fa-list" color="#6f42c1"/>

                <MenuCard link="/ot-notes-list" title="OT Notes" icon="fa-solid fa-file-medical" color="#fd7e14"/>

            </div>

            <h5 className="menu-section-title">Surgery Reports</h5>

            <div className="row">

                <MenuCard link="/ot-report" title="Surgery Status Report" icon="fa-solid fa-chart-line"
                          color="#dc3545"/>

            </div>

        </section>
    )
}
export default OtMenu;